import React from 'react';
import { useTranslation } from '../../config/TranslationProvider';

const Badge = ({type, description}) => {
    const translated = useTranslation(description);

    return (
        <li>
            <span className={'text-capitalize atbd_badge atbd_badge_' + type}>
                {translated}
            </span>
        </li>
    );
};

export default Badge;
